import { Chip } from "@dune/ui";
import { differenceInDays } from "date-fns";

export const InvitationStatusChip = ({
	sentAt,
	isAccountActivated,
	isSuspended,
}: {
	sentAt: Date | null;
	isAccountActivated: boolean;
	isSuspended: boolean;
}) => {
	const now = new Date();
	const sentDate = sentAt ? new Date(sentAt) : null;
	const expired = sentDate ? differenceInDays(now, sentDate) > 7 : false;

	let label = "";
	let color: "orange" | "gray" | "green" | "red" = "orange";
	if (isSuspended) {
		label = "Suspendu";
		color = "red";
	} else if (isAccountActivated) {
		label = "Actif";
		color = "green";
	} else if (sentDate && expired) {
		label = "Expirée";
		color = "gray";
	} else if (sentDate) {
		label = "En attente";
		color = "orange";
	} else if (!sentDate) {
		label = "Non envoyée";
		color = "gray";
	}

	return <Chip label={label} color={color} />;
};
